module.exports = require("bip39");